webpackJsonp([272895916635543],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n'], ['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Navigation = __webpack_require__(21);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _styles = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sticky = _styledComponents2.default.div(_templateObject);
	
	var InspiratiePage = function (_Component) {
	  _inherits(InspiratiePage, _Component);
	
	  function InspiratiePage() {
	    _classCallCheck(this, InspiratiePage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InspiratiePage.prototype.render = function render() {
	    var navItems = this.props.data.allNavigationJson.edges;
	    var inspiratieItems = this.props.data.allInspiratieJson.edges[0].node;
	    var subNavItems = navItems.filter(function (_ref, index) {
	      var navItem = _ref.node;
	      return index === 2;
	    });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Sticky,
	        null,
	        _react2.default.createElement(_Navigation2.default, { items: subNavItems, navType: 'sub' })
	      ),
	      _react2.default.createElement(
	        _styles.InspirationWrapper,
	        null,
	        inspiratieItems.inspiratie.map(function (inspiratie, index) {
	          return _react2.default.createElement(
	            _styles.ProjectsWrapperWider,
	            { key: index },
	            _react2.default.createElement(_styles.ProjectsImage, { src: inspiratie.img, alt: '' })
	          );
	        })
	      )
	    );
	  };
	
	  return InspiratiePage;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = InspiratiePage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-nieuws-inspiratie-js-0b91bc95222474901dc6.js